import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { services } from 'service';
import { useAppDispatch } from 'store/hooks';
import { logout } from 'thunks/account-thunk';

export const useUserAuth = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  return useQuery(['user'], services.manageUsersService.authenticate, {
    onError: () => {
      dispatch(logout());
      navigate('/');
    },
    refetchOnWindowFocus: true,
    retry: false
  });
};
